export const isAllowedRiderCode = (riderCode) => {
  return [
    "010",
    "011",
    "017",
    "020",
    "021",
    "022",
    "070",
    "071",
    "072",
    "073",
    "080",
    "081",
    "130",
    "143",
  ].includes(riderCode);
};
